import { render, staticRenderFns } from "./VFeedback.vue?vue&type=template&id=12535569&"
import script from "./VFeedback.vue?vue&type=script&lang=js&"
export * from "./VFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports